import React from "react"

import BaseTable from "./BaseTable"

import moment from "moment"

import Currency from '../../../utils/Currency'
import General from "../../../utils/General";

import PillCell from "./cells/PillCell";
import DownloadCell from "./cells/DownloadCell";


export default class CompanyInvoicesTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      companySubscription: props.companySubscription,
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._refresh())
  }

  _refresh(){
    this.table.current.refresh()
  }

  _getColumns() {
    let { subscription } = this.state
    return [
      {
        Header: 'Due At',
        id: 'due_at',
        accessor: companyInvoice => companyInvoice.due_at ? moment(companyInvoice.due_at).format('DD MMM YYYY') : '-'
      },
      {
        Header: 'Amount',
        id: 'total',
        Cell: (rowInfo) => {
          let companyInvoice = rowInfo.original

          let now = moment()
          let endDate = moment(companyInvoice.end_date)

          if(endDate >= now && companyInvoice.total){
            let key = companyInvoice.status === "paid" ? "total_paid" : "total_due"
            return Currency.format(
              companyInvoice.currency?.symbol,
              companyInvoice[key]
            )
          }

          return "-"
        },
      },
      {
        Header: 'Status',
        id: 'paid',
        Cell: (rowInfo) => {
          let companyInvoice = rowInfo.original

          let status = companyInvoice.status
          let className = ""
          if(status === "draft"){
            className = 'label-light-dark'
          }
          else if(status === "pending"){
            className = 'label-light-primary'
          }
          else if(status === "paid"){
            className = "label-light-success"
          }
          else{
            className = "label-light-danger"
          }

          return <PillCell text={General.toTitleCase(status)} className={className} />
        },
      },
      {
        Header: 'From',
        id: 'transaction_start_date',
        Cell: (rowInfo) => {
          let companyInvoice = rowInfo.original

          if(!companyInvoice.transaction_start_date){
            return "-"
          }

          return moment(companyInvoice.transaction_start_date).format('DD MMM YYYY')
        },
      },
      {
        Header: 'To',
        id: 'transaction_end_date',
        Cell: (rowInfo) => {
          let companyInvoice = rowInfo.original
          if(!companyInvoice.transaction_end_date){
            return "-"
          }
          return moment(companyInvoice.transaction_end_date).format('DD MMM YYYY')
        },
      },
      {
        Header: 'Actions',
        id: 'actions',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let companyInvoice = rowInfo.original
          return (
            <span style={{overflow: 'visible', position: 'relative', width: 150}}>
              {
                (companyInvoice.file) &&
                <DownloadCell
                  tooltip={"Download Invoice"}
                  onDownloadClicked={() => {
                    window.open(companyInvoice.file.url, '_blank')
                  }}
                />
              }
            </span>
          )
        }
      }
    ]
  }

  render() {
    let {
      companySubscription,
    } = this.state
    const columns = this._getColumns()

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.CompanyInvoices}?company_id=${companySubscription.company.id}`}
          noDataMessage={"No invoices found"}
          title={this.props.title}
          columns={columns}
          showExport={false}
          showHeader={false}
          defaultSorted={[
            {
              id: "due_at",
              desc: true
            }
          ]}
          showSearch={false}
          showPaginationBottom={true}
        />
      </div>
    )
  }
}

CompanyInvoicesTable.defaultProps = {

}
